import { Pagination } from '../../components/Pagination';
import { actionCreatorFactory } from 'typescript-fsa';
const actionCreator = actionCreatorFactory('Brand');

export const getBrandList = actionCreator('BRAND_LIST_GET');

export const updateBrandList = actionCreator<{
  brandIds: number[];
  pagination: Pagination;
}>('BRAND_LIST_UPDATE');

export const paginateBrandList = actionCreator<{ page: number }>(
  'BRAND_LIST_PAGINATE'
);

export const addBrand = actionCreator<{ id: number; gender: string }>(
  'BRAND_LIST_ADD_BRAND'
);



// WEBPACK FOOTER //
// ./src/store/BrandList/brandlist.actions.ts